module.exports = __webpack_public_path__ + "img/paypal.54dec04.png";